import React, { useEffect, useState } from "react";

const RolePermissionPage = () => {
    const token = localStorage.getItem("token");

    const [roles, setRoles] = useState([]);
    const [pages, setPages] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const [permissions, setPermissions] = useState({});
    const [loading, setLoading] = useState(false);
    const [pageNameMap, setPageNameMap] = useState({});
    /* ---------------- API CALLS ---------------- */

    const fetchRoles = async () => {
        const res = await fetch("https://mis.empowerplus.in/api/roles", {
            headers: { Authorization: `Bearer ${token}` }
        });
        setRoles(await res.json());
    };

    const fetchPages = async () => {
        const res = await fetch("https://mis.empowerplus.in/api/menus", {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();

        setPages(data);

        // ✅ BUILD ID → NAME MAP HERE
        const map = {};
        data.forEach(p => {
            map[p.id] = p.name; // menus use `name`
        });
        setPageNameMap(map);
    };


    // 🔥 ROLE ID USED HERE
    const fetchRolePermissions = async (roleId) => {
        setLoading(true);

        const res = await fetch(
            `https://mis.empowerplus.in/api/role-page-permissions/role/${roleId}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = await res.json();

        const map = {};
        data.forEach(p => {
            map[p.pageId] = {
                VIEW: p.canView,
                ADD: p.canAdd,
                EDIT: p.canEdit,
                DELETE: p.canDelete
            };
        });

        setPermissions(map);
        setLoading(false);
    };

    // const fetchRolePermissions = async (roleId) => {
    //     setLoading(true);
    //     const res = await fetch(
    //         // `https://mis.empowerplus.in/api/role-page-permissions/role/${roleId}`,
    //         `https://mis.empowerplus.in/api/role-page-permissions/role/1`,
    //         { headers: { Authorization: `Bearer ${token}` } }
    //     );

    //     const data = await res.json();

    //     const map = {};
    //     data.forEach(p => {
    //         map[p.pageId] = {
    //             VIEW: p.canView,
    //             ADD: p.canAdd,
    //             EDIT: p.canEdit,
    //             DELETE: p.canDelete
    //         };
    //     });

    //     setPermissions(map);
    //     setLoading(false);
    // };

    useEffect(() => {
        fetchRoles();
        fetchPages();
    }, []);

    useEffect(() => {
        if (selectedRoleId) fetchRolePermissions(selectedRoleId);
    }, [selectedRoleId]);

    /* ---------------- HANDLERS ---------------- */

    const togglePermission = (pageId, perm) => {
        setPermissions(prev => ({
            ...prev,
            [pageId]: {
                ...prev[pageId],
                [perm]: !prev[pageId]?.[perm]
            }
        }));
    };

    // const savePermissions = async () => {
    //     for (const page of pages) {
    //         const p = permissions[page.id];
    //         if (!p) continue;

    //         const permissionList = [];
    //         if (p.VIEW) permissionList.push("VIEW");
    //         if (p.ADD) permissionList.push("ADD");
    //         if (p.EDIT) permissionList.push("EDIT");
    //         if (p.DELETE) permissionList.push("DELETE");

    //         await fetch("https://mis.empowerplus.in/api/role-page-permissions/assign", {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`
    //             },
    //             body: JSON.stringify({
    //                 roleId: Number(selectedRoleId),
    //                 menuId: page.id,
    //                 permissions: permissionList
    //             })
    //         });
    //     }

    //     alert("Permissions updated successfully");
    // };


    const savePermissions = async () => {
        for (const page of pages) {
            const p = permissions[page.id];

            const permissionList = [];
            if (p?.VIEW) permissionList.push("VIEW");
            if (p?.ADD) permissionList.push("ADD");
            if (p?.EDIT) permissionList.push("EDIT");
            if (p?.DELETE) permissionList.push("DELETE");

            // ✅ If no permissions → remove from DB
            if (permissionList.length === 0) {
                await fetch(
                    `https://mis.empowerplus.in/api/role-page-permissions?roleId=${selectedRoleId}&menuId=${page.id}`,
                    {
                        method: "DELETE",
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );
            }
            // ✅ Otherwise assign/update
            else {
                await fetch(
                    "https://mis.empowerplus.in/api/role-page-permissions/assign",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            roleId: Number(selectedRoleId),
                            menuId: page.id,
                            permissions: permissionList
                        })
                    }
                );
            }
        }

        alert("Permissions updated successfully");
        fetchRolePermissions(selectedRoleId);
    };


    /* ---------------- UI ---------------- */

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Role Permission Management</h2>

            <select
                style={styles.select}
                value={selectedRoleId}
                onChange={e => setSelectedRoleId(e.target.value)}
            >
                <option value="">Select Role</option>
                {roles.map(r => (
                    <option key={r.id} value={r.id}>
                        {r.name}
                    </option>
                ))}
            </select>

            {loading && <p>Loading permissions...</p>}

            {!loading && selectedRoleId && (
                <>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Page</th>
                                <th style={styles.th}>VIEW</th>
                                <th style={styles.th}>ADD</th>
                                <th style={styles.th}>EDIT</th>
                                <th style={styles.th}>DELETE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pages.map(page => (
                                <tr key={page.id}>
                                    <td style={styles.td}>
                                        {pageNameMap[page.id] || page.name || "-"}
                                    </td>
                                    {["VIEW", "ADD", "EDIT", "DELETE"].map(perm => (
                                        <td style={styles.tdCenter} key={perm}>
                                            <input
                                                type="checkbox"
                                                checked={permissions[page.id]?.[perm] || false}
                                                onChange={() => togglePermission(page.id, perm)}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button style={styles.button} onClick={savePermissions}>
                        Save Permissions
                    </button>
                </>
            )}
        </div>
    );
};

/* ---------------- INLINE CSS ---------------- */

const styles = {
    container: {
        padding: "24px",
        background: "#f9fafb",
        minHeight: "100vh"
    },
    heading: {
        marginBottom: "16px"
    },
    select: {
        padding: "8px",
        marginBottom: "16px",
        width: "250px"
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        background: "#fff"
    },
    th: {
        border: "1px solid #ddd",
        padding: "10px",
        background: "#f1f1f1"
    },
    td: {
        border: "1px solid #ddd",
        padding: "10px"
    },
    tdCenter: {
        border: "1px solid #ddd",
        padding: "10px",
        textAlign: "center"
    },
    button: {
        marginTop: "16px",
        padding: "10px 20px",
        background: "#2563eb",
        color: "#fff",
        border: "none",
        cursor: "pointer"
    }
};

export default RolePermissionPage;
